"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("Modals/ModalComponent/Modal"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _LoginForm = _interopRequireDefault(require("Components/Forms/LoginForm"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class LoginModal extends _react.Component {
  state = {
    loading: false,
    error: undefined,
    status_messages: {}
  };
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (prev_props.open === true && props.open === false) {
      component.handleClose();
    }
  }
  handleClose = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      login: false,
      error: undefined
    });
  };
  handleValidation = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      login: true
    });
    if (props.onLogin instanceof Function) {
      props.onLogin();
    }
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['black', 'bg-white']
    }) : undefined;
    const status = (0, _getFormStatus.default)(state);
    const success = state.login === true ? (0, _getFormStatus.default)({
      info: 'Connexion réussie.'
    }) : undefined;
    const output = /*#__PURE__*/_react.default.createElement(_Modal.default, {
      open: props.open,
      onClose: props.onClose,
      title: "Connexion",
      scroll_area: props.scroll_area,
      bemit: ['small', 'simple'],
      src: props.trigger_src,
      close_label: state.login === true ? 'Fermer' : 'Annuler',
      close_classes: "c-btn c-btn--small c-btn--black"
    }, success ? undefined : /*#__PURE__*/_react.default.createElement(_LoginForm.default, {
      onLogin: component.handleValidation,
      redirect: false
    }), status, success, props.children, loader);
    return output;
  }
}
exports.default = LoginModal;
LoginModal.propTypes = {
  open: _propTypes.default.bool,
  scroll_area: _propTypes.default.string,
  trigger_src: _propTypes.default.object,
  onClose: _propTypes.default.func.isRequired,
  onLogin: _propTypes.default.func
};
LoginModal.defaultProps = {
  open: false,
  scroll_area: '.front-page'
};
